
import React from 'react';

const XlsxIcon = (props) => (
    <svg width={40} height={40} fill="none" viewBox="0 0 40 40" {...props}>
        <path
            stroke="#D5D7DA"
            strokeWidth={1.5}
            d="M7.75 4A3.25 3.25 0 0 1 11 .75h16c.121 0 .238.048.323.134l10.793 10.793a.46.46 0 0 1 .134.323v24A3.25 3.25 0 0 1 35 39.25H11A3.25 3.25 0 0 1 7.75 36z"
        />
        <path stroke="#D5D7DA" strokeWidth={1.5} d="M27 .5V8a4 4 0 0 0 4 4h7.5" />
        <rect width={33} height={16} x={1} y={18} fill="#079455" rx={2} />
        <path
            fill="#fff"
            d="m6.312 22.727 1.467 2.479h.057l1.473-2.479h1.737l-2.22 3.637L11.096 30H9.327l-1.491-2.482h-.057L6.287 30H4.526l2.276-3.636-2.233-3.637zM12.02 30v-7.273h1.537v6.005h3.118V30zm9.619-5.181a.9.9 0 0 0-.366-.668q-.323-.238-.877-.238-.376 0-.636.107a.9.9 0 0 0-.397.288.7.7 0 0 0-.135.419.6.6 0 0 0 .081.34.9.9 0 0 0 .253.253q.16.103.369.18.21.075.447.129l.654.156q.476.106.873.284.398.177.69.437.29.259.45.61.164.353.167.807-.004.667-.34 1.157-.334.487-.967.757-.628.266-1.516.266-.881 0-1.534-.27a2.25 2.25 0 0 1-1.016-.799q-.362-.533-.38-1.317h1.488q.025.366.21.61.188.242.5.366.317.12.714.12.39 0 .678-.113a1.04 1.04 0 0 0 .452-.316.73.73 0 0 0 .16-.465q-.001-.244-.146-.412a1.1 1.1 0 0 0-.42-.284 4 4 0 0 0-.67-.213l-.792-.199q-.92-.224-1.453-.7-.532-.475-.529-1.282-.003-.66.352-1.154.359-.493.983-.77.625-.277 1.42-.277.81 0 1.414.277.608.276.945.77t.348 1.144zm4.05-2.092 1.466 2.479h.057l1.473-2.479h1.737l-2.22 3.637L30.471 30h-1.769l-1.491-2.482h-.057L25.662 30h-1.761l2.276-3.636-2.233-3.637z"
        />
    </svg>
);

export default XlsxIcon;